import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const pageBlockClasses = {
  wrapper: '!p-16 sm:!p-24',
};

export const getSummaryWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: `repeat(${length}, 1fr)`,
  },
});

export const summaryCardStyles = {
  padding: '4px 8px',
};
